module.exports = __webpack_public_path__ + "static/edf_ingeum-a71189d5c1511e4925326311bfed8bbb.webm";